import { factory, getResponseCamelization } from '@repo-level/core-front';
import {
  CMSApiBase,
  CMSImageBase,
  buildCmsUrl,
  getResponseCMS,
} from 'api/cms/base';
import { isCMSV3 } from 'helpers/conf';

export interface MobileAppApi extends CMSApiBase {
  showAndroid: boolean;
  androidApk?: CMSImageBase;
}

export const mobileAppV3 = factory((r) => () =>
  r<MobileAppApi>('get', buildCmsUrl({ path: 'mobile-app' }))
);

export const mobileAppV4 = factory((r) => () =>
  r<MobileAppApi>(
    'get',
    buildCmsUrl({ path: 'mobile-app', additionalParams: { populate: 'deep' } }),
    undefined,
    { transformResponse: [getResponseCamelization(), getResponseCMS] }
  )
);

export const mobileApp = isCMSV3 ? mobileAppV3 : mobileAppV4;
